module.exports = __webpack_public_path__ + "fonts/HFDigits.ddf52b40.ttf";